<template>
  <div class="cashflow-type-weekly-variable card-box">
    <div class="title">
      <span>{{ titles.cardTitle }}</span>
    </div>

    <expense-progress :recommended-or-expected-amount="variableExpenses.recommendedOrExpectedAmount"
                      :recommended-or-expected-label="titles.expenseProgress.recommendedLabel"
                      :up-to-now-label="titles.expenseProgress.actualsLabel"
                      :up-to-now-amount="variableExpenses.upToNowAmount"
                      :show-warning-if-exceeding-budget="true"/>

    <predicted-category-sections :actuals-title="titles.realExpenses.categorySections.actualsTitle"
                                 :recommended-title="titles.realExpenses.categorySections.recommendedTitle"
                                 :categories="variableExpenses.weekly.realExpenses.categories"
                                 :initially-expanded="true"
                                 :show-recommended-title="true"
                                 :title="titles.realExpenses.categorySections.mainTitle"
                                 :expense-category="titles.expenseCategory"
                                 v-on:section-clicked="sectionClicked(CASHFLOW_TYPE, $event)"
                                 v-on:category-sections-clicked="categorySectionsClicked(CASHFLOW_TYPE, $event)">
      <template v-slot:transactions="slotProps">
        <div class="transaction-list">
          <transaction class="transaction-details"
                                     v-for="transaction in slotProps.transactions"
                                     :transaction="transaction"
                                     :can-edit-category="true"
                                     :category-name="categoryName"
                                     v-bind:key="transaction.transactionId">

          </transaction>
        </div>
      </template>
    </predicted-category-sections>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import PredictedCategorySections from '../../../generic-components/cashflow-types/cashflow-types-base/PredictedCategorySections.vue';
import ExpenseProgress from '../../../generic-components/cashflow-types/cashflow-types-base/ExpenseProgress.vue';
import Transaction from '../../../generic-components/cashflow-types/cashflow-types-base/Transaction.vue';
import CashflowAnalytics from '../../../generic-components/CashflowAnalytics.vue';
import cashflowViewConsts from '../../../../../../../../../constants/cashflow-view';

export default {
  name: 'CashflowTypeWeeklyVariables',
  mixins: [CashflowAnalytics],
  components: {
    Transaction,
    ExpenseProgress,
    PredictedCategorySections,
  },
  data() {
    return {
      CASHFLOW_TYPE: 'weeklyVariables',
    };
  },
  computed: {
    ...mapState('cashflowView', ['cashflowUITree']),
    variableExpenses() {
      return this.cashflowUITree[cashflowViewConsts.cashflowTypes.variableExpense];
    },
    categoryName() {
      return cashflowViewConsts.CATEGORY_NAMES.VARIABLE;
    },
    titles() {
      return {
        expenseProgress: {
          actualsLabel: 'יצא עד עכשיו',
          recommendedLabel: 'מומלץ להוציא עד',
        },
        realExpenses: {
          categorySections: {
            actualsTitle: 'יצא',
            recommendedTitle: 'נשאר להוציא',
            mainTitle: 'פירוט שבועי של הוצאות משתנות',
          },

        },
        cardTitle: 'הוצאות משתנות',
        expenseCategory: 'משתנות',
      };
    },
  },
};
</script>

<style lang="scss">
  @import '../../../../../../../../../../node_modules/base-ui/src/scss/riseup-colors';
  @import '../../../../../../../../../scss/mixins';

  .cashflow-type-weekly-variable {
    @include cashflow-card;

    .title {
      @include cashflow-card-title;
    }

    .cashflow-type-color {
      color: $riseup_yellow;
    }

    .cashflow-type-background-color {
      background-color: $riseup_yellow;
    }
  }

</style>
